import formattedMessage from '../languageModule';

const home = '';
const users = 'users';
const transactions = 'transactions';
const groups = 'groups';
const store = 'store';
const register = 'register';
const electronicPurse = 'electronic-purse';
const promotions = 'promotions';
const merchant = 'merchant';
const customerCare = 'customer-care';

export const routes = [
	{ routeName: 'Home', route: home, label: formattedMessage.home, subRoutes: [] },
	{
		routeName: 'Users',
		route: users,
		label: formattedMessage.users,
		subRoutes: [
			{
				route: `${users}`,
				label: formattedMessage.usersList,
			},
			{
				route: `${users}/users-management`,
				label: formattedMessage.usersManagement,
			},
		],
	},
	{
		routeName: 'Transactions',
		route: transactions,
		label: formattedMessage.transactions,
		subRoutes: [
			{
				route: `${transactions}`,
				label: formattedMessage.transactionList,
			},
			/*			{
				route: `${transactions}/post-accounting-transfer`,
				label: formattedMessage.postAccountingTransfer,
			},
 */
		],
	},
	{
		routeName: 'Groups',
		route: groups,
		label: formattedMessage.groups,
		subRoutes: [
			{
				route: `${groups}`,
				label: formattedMessage.groupsList,
			},
			{
				route: `${groups}/group-management`,
				label: formattedMessage.groupManagement,
			},
		],
	},
	{
		routeName: 'Merchant',
		route: merchant,
		label: formattedMessage.merchant,
		subRoutes: [
			{
				route: `${merchant}`,
				label: formattedMessage.merchantList,
			},
			{
				route: `${merchant}/merchant-management`,
				label: formattedMessage.merchantManagement,
			},
		],
	},
	{
		routeName: 'Store',
		route: store,
		label: formattedMessage.store,
		subRoutes: [
			{
				route: `${store}`,
				label: formattedMessage.storeList,
			},
			{
				route: `${store}/store-management`,
				label: formattedMessage.storeManagement,
			},
		],
	},
	{
		routeName: 'Register',
		route: register,
		label: formattedMessage.register,
		subRoutes: [
			{
				route: `${register}`,
				label: formattedMessage.registerList,
			},
			{
				route: `${register}/register-management`,
				label: formattedMessage.registerManagement,
			},
		],
	},
	{
		routeName: 'ElectronicPurse',
		route: electronicPurse,
		label: formattedMessage.electronicPurse,
		subRoutes: [
			{
				route: `${electronicPurse}`,
				label: formattedMessage.couponList,
			},
			{
				route: `${electronicPurse}/epurse-management`,
				label: formattedMessage.couponManagement,
			},
		],
	},
	{
		routeName: 'CustomerCare',
		route: customerCare,
		label: formattedMessage.customerCare,
		subRoutes: [
			{
				route: `${customerCare}`,
				label: formattedMessage.searchUser,
			},
			{
				route: `${transactions}`,
				label: formattedMessage.searchTransactions,
			},
		],
	},
	{
		routeName: 'Promotions',
		route: promotions,
		label: formattedMessage.promotions,
		subRoutes: [
			{
				route: `${promotions}`,
				label: formattedMessage.promotionList,
			},
			{
				route: `${promotions}/cashback-list`,
				label: formattedMessage.cashbackList,
			},
			{
				route: `${promotions}/promotion-management`,
				label: formattedMessage.newPromotion,
			},
		],
	},
];
